import { trackCustomEvent } from "./customEvents"
import { currentRegionFromMetaTag } from "../currentRegionFromMetaTag"
import { commissioningRegionFromMetaTag } from "../commissioningRegionFromMetaTag"
import { pageIsDraft } from "../tcEventsCollector"

/**
 * Possibly emit an articleViewed custom event to Braze.
 * This is safe to call regardless of whether the Braze SDK has been initialised,
 * as the way our code is set up, the event will get pushed into a pending queue
 * if Braze isn't initialised.
 */
export function trackArticleViewed(contentId: string | number) {
  if (pageIsDraft()) {
    return
  }

  trackCustomEvent("articleViewed", {
    articleId: contentId.toString(),
    userEdition: currentRegionFromMetaTag(),
    commissioningEdition: commissioningRegionFromMetaTag(),
  })
}
